function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
module.exports = function (priceTaxFeeAdjusterBase, purchaseService, clone) {
  var priceTaxFeeAdjuster = /*#__PURE__*/function (_priceTaxFeeAdjusterB) {
    function priceTaxFeeAdjuster(supplementalData) {
      var _this;
      _classCallCheck(this, priceTaxFeeAdjuster);
      _this = _callSuper(this, priceTaxFeeAdjuster, [supplementalData]);
      _this.name = "tax";
      _this.id = priceTaxFeeAdjuster.nextId;
      priceTaxFeeAdjuster.nextId++;
      _this.supplementalData = null;
      _this.priority = priceTaxFeeAdjuster.taxPriority;
      _this.roundByGroup = "tax";
      _this.groupIdPath = "extra.taxRule.name";
      return _this;
    }
    _inherits(priceTaxFeeAdjuster, _priceTaxFeeAdjusterB);
    return _createClass(priceTaxFeeAdjuster, [{
      key: "setTaxincFinal",
      value: function setTaxincFinal(p, index, clonedList) {
        var incExc = {
          inc: 0,
          exc: 0
        };

        /*****************************************************************************
         * any promo can affect tax inclusivity status with the following rules
         * - if all "taxinc"s are "false", product "taxinc" is set to "false"
         * - otherwise, if one promo's "taxinc" is "true" - then the product "taxinc" is true
         * furthermore, once a promo is activated on an item, any item with the same upc gets the promo tax-inclusivity rule applied
         ******************************************************************************/
        if (p.priceTaxFeeAdjustments && p.priceTaxFeeAdjustments.length) {
          var promos = p.priceTaxFeeAdjustments.filter(function (a) {
            return a.name === "promo";
          });
          if (promos.length) {
            var allAreTaxExclusive = promos.every(function (a) {
              return !a.extra.promo.pricing.incltaxes;
            });
            // as long as not all are tax-exclusive the final status will be tax-inclusive
            var thisTaxincFinal = !allAreTaxExclusive;
            // get all "winning" promos - the ones that were part of deciding who shall set the products inclusivity status
            // (this just excludes tax-exclusive promos when there were one or more other tax-inclusive promos)
            var taxincPromos = promos.filter(function (a) {
              return a.extra.promo.pricing.incltaxes == thisTaxincFinal;
            });
            var affectedUpcsArrayList = taxincPromos.map(function (a) {
              return a.extra.promo.upcs;
            });
            var affectedUpcs = [].concat.apply([], affectedUpcsArrayList);
            for (var c = 0; c < index; ++c) {
              if (affectedUpcs.includes(clonedList[c].upc) && !(clonedList[c].priceTaxFeeAdjustments && clonedList[c].priceTaxFeeAdjustments.find(function (a) {
                return a.name === "promo";
              }))) {
                clonedList[c].taxincFinal = thisTaxincFinal ? {
                  inc: clonedList[c].effectiveQuantity,
                  exc: 0
                } : {
                  inc: 0,
                  exc: clonedList[c].effectiveQuantity
                };
              }
            }

            // we shall just take the first promo's affected amount and ignore more complex scenarios where multiple promos affect the inclusivity progressively
            var arbitraryPromoAffectedAmount = promos[0].extra.qtyAffected ? promos[0].extra.qtyAffected : p.effectiveQuantity;
            incExc[thisTaxincFinal ? "inc" : "exc"] = arbitraryPromoAffectedAmount;
          }
        }
        p.taxincFinal = p.pricing.incltaxes ? {
          inc: p.effectiveQuantity - incExc.exc,
          exc: incExc.exc
        } : {
          inc: incExc.inc,
          exc: p.effectiveQuantity - incExc.inc
        };
      }
    }, {
      key: "calculate",
      value: function calculate(productlist) {
        var _this2 = this;
        var realproductlist = productlist.filter(function (a) {
          return typeof a.upc !== "undefined" && !a.isFree;
        });

        // splice out all priceTaxFeeAdjustments of the type that this function will create before recalc otherwise we'll get two with the same name/id
        var _iterator = _createForOfIteratorHelper(realproductlist),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _p = _step.value;
            if (_p.priceTaxFeeAdjustments && _p.priceTaxFeeAdjustments.length) {
              _p.priceTaxFeeAdjustments = _p.priceTaxFeeAdjustments.filter(function (a) {
                return !(a.name === _this2.name && a.id === _this2.id);
              });
            }
          }

          /************************************************************
           * working out if product is 'fee/tax-inclusive/exclusive' is non-trivial
           * it might just be the p.pricing.incltaxes flag set to true
           * or it may be set by a promo, if the promo gets applied and contains the "incltaxes: true" setting
           * except that at the point we are calculating taxes we have not yet calculated which of the promos get activated on which product
           * and we can't apply post-tax promos before taxes and fees because they will affect the tax and fee calculations since they lower the net product prices on which the taxes and fees may be based
           * so we have to calculate them on a dummy product list - "clonedProductListWithPromosCalculated"
           ************************************************************/
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var clonedProductListWithPromosCalculated = clone(realproductlist);
        // var priceTaxFeeAdjuster = new promoService.priceTaxFeeAdjuster(
        //   clonedProductListWithPromosCalculated
        // );
        var promoPriceTaxFeeAdjusters = purchaseService.priceTaxFeeAdjusters.filter(function (a) {
          return a.name === "promo";
        });
        if (!promoPriceTaxFeeAdjusters.length) {
          console.warn("Warning! promoPriceTaxFeeAdjusters has length 0!");
        }
        promoPriceTaxFeeAdjusters.forEach(function (a) {
          return a.calculate(clonedProductListWithPromosCalculated);
        });
        clonedProductListWithPromosCalculated.forEach(function (p, index, clonedList) {
          return _this2.setTaxincFinal(p, index, clonedList);
        });
        for (var productIndex = 0, p; p = realproductlist[productIndex]; ++productIndex) {
          var priceTaxFeeAdjustments = [];
          var taxRules = p.revauths.filter(function (a) {
            return a.type === "Tax";
          });
          if (!taxRules.length) {
            continue;
          }

          // first calculate taxes on skuprice
          // some optimization: we only need to calculate lineItemPrice if there are any rate_decibps ("fractions of price") rules
          if (taxRules.find(function (a) {
            return a.rate_decibps;
          })) {
            var lineItemInitialUnitPrice = p.skuprice / p.skuqty;
            var precedingPriceUnitAdjustments = p.priceTaxFeeAdjustments ? p.priceTaxFeeAdjustments.filter(function (a) {
              return a.priority < _this2.priority;
            }).reduce(function (total, a) {
              return total + a.price;
            }, 0) / p.effectiveQuantity : 0;
            var lineItemUnitPrice = lineItemInitialUnitPrice + precedingPriceUnitAdjustments;
          }
          var _iterator2 = _createForOfIteratorHelper(taxRules),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var taxRule = _step2.value;
              var priceAdjustment = 0; // if the price includes tax then the real price is skuprice minus tax

              if (taxRule.per_item_cents) {
                // if it is a multi-item then tax applies per unit and not per purchase item
                var incTaxAmount = clonedProductListWithPromosCalculated[productIndex].taxincFinal.inc * taxRule.per_item_cents / (p.byweight ? p.effectiveQuantity : 1);
                var excTaxAmount = clonedProductListWithPromosCalculated[productIndex].taxincFinal.exc * taxRule.per_item_cents / (p.byweight ? p.effectiveQuantity : 1);
              } else {
                var taxFraction = taxRule.rate_decibps / 100000;

                // if the price includes taxes then the real fraction is the quotient of 1 + the exclusive fraction
                var incTaxFraction = taxFraction / (1 + taxFraction);
                var excTaxFraction = taxFraction;
                var incTaxAmount = clonedProductListWithPromosCalculated[productIndex].taxincFinal.inc * lineItemUnitPrice * incTaxFraction;
                var excTaxAmount = clonedProductListWithPromosCalculated[productIndex].taxincFinal.exc * lineItemUnitPrice * excTaxFraction;
              }
              if (incTaxAmount) {
                priceTaxFeeAdjustments.push({
                  name: this.name,
                  id: this.id,
                  priority: this.priority,
                  price: -incTaxAmount,
                  tax: incTaxAmount,
                  fee: 0,
                  extra: {
                    taxRule: taxRule
                  }
                });
              }
              if (excTaxAmount) {
                priceTaxFeeAdjustments.push({
                  name: this.name,
                  id: this.id,
                  priority: this.priority,
                  price: 0,
                  tax: excTaxAmount,
                  fee: 0,
                  extra: {
                    taxRule: taxRule
                  }
                });
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          if (priceTaxFeeAdjustments.length) {
            p.priceTaxFeeAdjustments = p.priceTaxFeeAdjustments || [];
            Array.prototype.push.apply(p.priceTaxFeeAdjustments, priceTaxFeeAdjustments); // merge new priceTaxFeeAdjustments array into existing p.priceTaxFeeAdjustments array
            var priceTaxFeeAdjustments = [];
          }

          // then calculate taxes on fees
          // fees are stored in the object as priceTaxFeeAdjustments and must always come before taxes so if there are no priceTaxFeeAdjustments or none are feeRules, or they are not taxable, or they are sum-0 there are no fees to tax
          var taxableFeeAdjustments = p.priceTaxFeeAdjustments && p.priceTaxFeeAdjustments.length ? p.priceTaxFeeAdjustments.filter(function (a) {
            return a.name === "fee" && a.extra && a.extra.feeRule && a.extra.feeRule.taxable;
          }) : 0;
          if (!taxableFeeAdjustments.length) {
            continue;
          }

          // only percentage taxes can be applied to taxable fees
          var taxPercentRules = taxRules.filter(function (a) {
            return a.rate_decibps;
          });
          if (!taxPercentRules.length) {
            continue;
          }

          // we pull the final fee amount of the item by summing the taxable fees
          var totalTaxableFees = taxableFeeAdjustments.reduce(function (total, current) {
            return total + current.fee;
          }, 0);
          if (!totalTaxableFees) {
            continue;
          }
          var _iterator3 = _createForOfIteratorHelper(taxPercentRules),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var taxPercentRule = _step3.value;
              var _taxFraction = taxPercentRule.rate_decibps / 100000;
              var taxAmount = totalTaxableFees * _taxFraction;
              var incQty = clonedProductListWithPromosCalculated[productIndex].taxincFinal.inc;
              var excQty = clonedProductListWithPromosCalculated[productIndex].taxincFinal.exc;
              if (incQty) {
                var incTaxAmount = taxAmount * (incQty / p.effectiveQuantity);
                priceTaxFeeAdjustments.push({
                  name: this.name,
                  id: this.id,
                  priority: this.priority,
                  price: -incTaxAmount,
                  tax: incTaxAmount,
                  fee: 0,
                  extra: {
                    totalTaxableFees: totalTaxableFees,
                    taxRule: taxPercentRule
                  }
                });
              }
              if (excQty) {
                var excTaxAmount = taxAmount * (excQty / p.effectiveQuantity);
                priceTaxFeeAdjustments.push({
                  name: this.name,
                  id: this.id,
                  priority: this.priority,
                  price: 0,
                  tax: excTaxAmount,
                  fee: 0,
                  extra: {
                    totalTaxableFees: totalTaxableFees,
                    taxRule: taxPercentRule
                  }
                });
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          if (priceTaxFeeAdjustments.length) {
            p.priceTaxFeeAdjustments = p.priceTaxFeeAdjustments || [];
            Array.prototype.push.apply(p.priceTaxFeeAdjustments, priceTaxFeeAdjustments); // merge new priceTaxFeeAdjustments array into existing p.priceTaxFeeAdjustments array
          }
        }
      }
    }]);
  }(priceTaxFeeAdjusterBase);
  priceTaxFeeAdjuster.nextId = 0;
  priceTaxFeeAdjuster.taxPriority = 0; // so positive priorities are post-tax adjusters and negative values are pre-tax

  return {
    priceTaxFeeAdjuster: priceTaxFeeAdjuster
  };
}(require("../base.js"), require('../../module/purchase/service.js'), require("clone"));